import React, { useRef, useState } from 'react';
import {Link} from "react-router-dom";
import {Bars3CenterLeftIcon} from "@heroicons/react/16/solid";
import Sidebar from "./Sidebar";

function scrollToTop() {
    sessionStorage.setItem('scrollPosition', window.scrollY.toString());
    window.scrollTo(0, 0);
}

const Menu = ({ sidebarOpen, toggleSidebar }) => {

    const sidebarContainerRef = useRef(null);
    const sidebarElementRef = useRef(null);
    const [animationComplete, setAnimationComplete] = useState(false);

    const toggleSidebarState = () => {
        if (!sidebarOpen) {
            setAnimationComplete(false);
        }
        toggleSidebar(!sidebarOpen);
    };

    React.useEffect(() => {
        if (sidebarOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [sidebarOpen]);

    React.useEffect(() => {
        const sidebarElement = sidebarElementRef.current;
        if (sidebarOpen && sidebarElement && !animationComplete) {
            sidebarElement.style.left = "-100%";
            sidebarElement.style.transition = "left 0s";
            requestAnimationFrame(() => {
                sidebarElement.style.left = "0";
                sidebarElement.style.transition = "left 0.5s";
                setAnimationComplete(true);
            });
        } else if (!sidebarOpen && sidebarElement && animationComplete) {
            sidebarElement.style.left = "0";
            sidebarElement.style.transition = "left 0.5s";
            requestAnimationFrame(() => {
                sidebarElement.style.left = "-100%";
                sidebarElement.style.transition = "left 0.5s";
                setTimeout(() => {
                    setAnimationComplete(false);
                    toggleSidebar(false);
                }, 500);
            });
        }
    }, [sidebarOpen, animationComplete]);

    return (
        <div className="fixed bottom-0 left-0 z-50 w-full lg:w-[12rem]">
            <div className="h-[60px] flex items-center justify-between px-4 bg-white dark:bg-dark-925 lg:bg-transparent border-t border-gray-200 dark:border-dark-700 shadow-[0_-2px_8px_rgba(0,0,0,0.05)] dark:shadow-[0_-12px_32px_rgba(0,0,0,0.32)]">
                <button
                    ref={sidebarContainerRef}
                    onClick={toggleSidebarState}
                    className="group flex items-center justify-center h-11 w-11 rounded-xl border border-cyan-200 bg-cyan-50 text-cyan-900 hover:bg-cyan-100 active:scale-95 transition-all duration-200 shadow dark:border-panda-cyan/30 dark:bg-panda-cyan/10 dark:text-panda-cyan dark:hover:bg-panda-cyan/15"
                >
                    <Bars3CenterLeftIcon
                        className={`h-5 w-5 transition-opacity duration-200 group-hover:scale-110 ${sidebarOpen ? 'opacity-0' : 'opacity-100'}`}
                    />
                </button>
                <div className="flex flex-col items-center">
                    <span className="text-[11px] text-cyan-900 dark:text-gray-100 uppercase tracking-wider">Arcado</span>
                    <span className="text-[9px] text-gray-400 dark:text-gray-500 tracking-wide">Administrator</span>
                </div>
                <Link to="/home" onClick={scrollToTop}>
                    <img
                        src="/images/arcado-logo-solo-circle.png"
                        alt="Logo"
                        className="w-9 h-9 object-cover rounded-xl border border-cyan-100 dark:border-dark-700 shadow"
                    />
                </Link>
            </div>

            {sidebarOpen && (
                <>
                    {/* Mobile overlay */}
                    <div
                        className="fixed inset-0 z-0 bg-black/55 backdrop-blur-sm lg:hidden"
                        onClick={() => {
                            const sidebarElement = sidebarElementRef.current;
                            if (sidebarElement) {
                                sidebarElement.style.left = "-100%";
                                setTimeout(() => toggleSidebar(false), 250);
                            }
                        }}
                    />

                    {/* Desktop overlay */}
                    <div
                        className="hidden lg:block fixed top-0 left-[12rem] h-full w-[calc(100%-12rem)] bg-white/60 dark:bg-black/35 backdrop-blur-[1px] z-0"
                        onClick={() => toggleSidebar(false)}
                    />

                    {/* Sidebar */}
                    <Sidebar ref={sidebarElementRef} />
                </>
            )}
        </div>
    );
}

export default Menu;
